import { Company } from "../models/company";

export const isAllied = (company?: Company) => {
  if (company && company?.name) {
    return company?.name?.toLowerCase()?.includes("allied");
  }

  return false;
};
